import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const SkeletonWrapper = styled.div`
  flex-direction: column;
  width: 100%;
  height: 100%;
`

export const SkeletonChartWrapper = styled.div`
  width: 100%;
  height: calc(100% - 2 * ${Spacing.S16} - ${Spacing.S8});
  margin-bottom: ${Spacing.S8};
`

export const SkeletonXAxisWrapper = styled.div`
  flex-shrink: 0;
  width: 100%;
  height: ${Spacing.S16};
  margin-top: auto;
  margin-bottom: ${Spacing.S16};
`

export const BarChartStoryWrapper = styled.div`
  height: 100vh;
`

interface BarLabelRowWrapperProps {
  barWidth: number
}

export const BarLabelRowWrapper = styled.div<BarLabelRowWrapperProps>`
  width: ${({ barWidth }) => barWidth}px;
  min-width: max-content;
  height: 100%;
`
